export default __webpack_public_path__ + "static/media/linkedinIcon.0d55e41f.png";